var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobConwayShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2b2b89;\n      }\n\n      .cls-2 {\n        fill: #3939b2;\n      }\n\n      .cls-3 {\n        fill: #5b4956;\n      }\n\n      .cls-4 {\n        fill: #2abff4;\n      }\n\n      .cls-5 {\n        fill: #232368;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "537.12 380.08 499.55 385.72 421.38 385.72 421.38 319.18 537.12 336.57 537.12 380.08"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "528.55 268.07 178.24 346.24 83.91 372.87 476.42 374.56 528.55 268.07"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "232.9 333.4 202.06 374.56 83.91 372.67 178.78 345.88 232.9 333.4"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "470.86 396.79 119.01 388.94 83.91 372.87 473.99 374.94 470.86 396.79"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "498.4 438.64 293.31 432.73 283.3 419.02 498.4 422.98 498.4 438.64"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "380.49 414.17 206.74 404.2 206.74 397.08 380.49 387.11 380.49 414.17"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "498.94 422.98 283.81 419.54 277.27 372.48 476.01 374.94 498.94 422.98"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "476.42 374.56 323.16 372.64 354.55 325.55 527.21 268.12 476.42 374.56"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "527.2 268 421.25 373.95 476.09 375.86 527.2 268"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobConwayShip);
export default __webpack_public_path__ + "static/media/mob-conway-ship.f4d7247bf280812af720b08c743865d2.svg";
export { ForwardRef as ReactComponent };